<template>
  <div class="ask-question">
    <editWin
      v-model="show"
      @addSuccess="updataSuccess"
      title="患者提问题"
      addApi="/saasbaihui/saveFeedbackMessageOffline"
      :formInputList="formInputList"
      :titleSplicing="false"
      :formatData="formatData"
    >
    </editWin>
  </div>
</template>

<script>
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
export default {
  props: {
    patientCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isFirst: true,
      show: false,
      activeItem: null,
      formInputList: [],
    };
  },
  methods: {
    open(res) {
      this.activeItem = res;
      this.restart();
      this.show = true;
    },
    restart() {
      let d = dayjs();
      let startHour = 1;
      let endHour = 24;
      if (!this.isFirst) {
        startHour = 0.5;
        endHour = 1;
      }

      this.formInputList = [
        {
          type: "textarea",
          field: "feedbackQuestion",
          title: "患者的问题",
          value: "",
          required: true,
          props: {
            rows: 5,
          },
        },
        {
          type: "component",
          field: "promiseDate",
          component: "dateTimePicker",
          title: "承诺回复截止时间",
          value: d.add(startHour, "hour").format("YYYY-MM-DD HH:mm:ss"),
          required: true,
          props: {
            disabledDate: (data) => {
              let dS = d.add(startHour, "hour");
              let dE = d.add(endHour, "hour");
              return !dayjs(data).isBetween(dS, dE, "date", "[]");
            },
            nowDate: d.format("YYYY-MM-DD HH:mm:ss"),
            startHour,
            endHour,
          },
        },
      ];
    },
    formatData(data) {
      let d = dayjs(data.promiseDate).diff(dayjs(), "minutes");
      let remindDate = dayjs()
        .add((d / 3) * 2, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");

      Object.assign(data, {
        patientCode: this.patientCode,
        remindDate, //	提醒时间 （提醒时间距离承诺回复截止时间2/3的时间）
      });
      return data;
    },
    updataSuccess() {
      this.show = false;
      this.$emit("success");
    },
  },
};
</script>

<style scoped>
.ask-question {
}
</style>